// extracted by mini-css-extract-plugin
export default {"title":"styles_title__vhhMt","title_row":"styles_title_row__DhhSp","title_bar":"styles_title_bar__-5Qlj"};